<template>
  <div id="app">
    <form-validate />
  </div>
</template>

<script>
import FormValidate from "./components/form.vue";

export default {
  name: "App",
  components: {
    FormValidate,
  },
};
</script>


<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #746c71;
  margin-top: 60px;
  max-width: 600px;
  margin: 0 auto;
}
.md-snackbar {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  min-width: 288px;
  max-width: 568px;
  min-height: 48px;
  max-height: 80px;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 14;
  border-radius: 2px;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: background-color, color, opacity, transform;
}
.md-snackbar.md-position-center {
  margin: 0 auto;
  right: 0;
  bottom: 0;
  left: 0;
}
.md-snackbar.md-position-center.md-snackbar-enter,
.md-snackbar.md-position-center.md-snackbar-leave-active {
  transform: translate3D(0, calc(100% + 8px), 0);
}
.md-snackbar.md-position-left {
  bottom: 24px;
  left: 24px;
}
.md-snackbar.md-position-left.md-snackbar-enter,
.md-snackbar.md-position-left.md-snackbar-leave-active {
  transform: translate3D(0, calc(100% + 32px), 0);
}
.md-snackbar-enter,
.md-snackbar-enter .md-snackbar-content,
.md-snackbar-leave-active,
.md-snackbar-leave-active .md-snackbar-content {
  opacity: 0;
}
.md-snackbar-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: opacity 0.38s cubic-bezier(0.55, 0, 0.55, 0.2);
}
.md-snackbar-content .md-button {
  min-width: 0;
  margin: -8px -8px -8px 36px;
}
.md-snackbar-content .md-button + .md-button {
  margin-left: 16px;
}
@media (max-width: 600px) {
  .md-snackbar {
    left: 0;
    transform: none;
    border-radius: 0;
  }
  .md-snackbar-content .md-button {
    margin-left: 12px;
  }
}
</style>
